import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M17.97 6.97 4.11 14.89l5.445 5.444L17.97 6.97Z",
  stroke: "currentColor",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "m20.5 15 .396.305a.5.5 0 0 0-.396-.805v.5Zm-5 6.5-.396-.305A.5.5 0 0 0 15.5 22v-.5Zm0-6h5v-1h-5v1Zm4.604-.805-5 6.5.792.61 5-6.5-.792-.61ZM15.5 22H21v-1h-5.5v1Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }